import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded'
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded'
import { Box, IconButton } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectFursuit } from '../../../state/voting/fursuit'
import { pallete } from '../../../theme'
import { isDefined, notDefined } from '../../../utils'
import { VotingCard } from './Card'

const carouselControlsStyle = {
  wrapper: {
    '& button:hover': {
      backgroundColor: pallete.headerColor,
      opacity: '1!important'
    }
  },
  leftButton: {
    position: 'absolute',
    left: '5px',
    top: '5px',
    background: pallete.headerColor,
    color: pallete.paperColor
  },
  rightButton: {
    position: 'absolute',
    right: '5px',
    top: '5px',
    background: pallete.headerColor,
    color: pallete.paperColor
  }
}

const VotingCarouselControls = (props) => {
  return (
    <Box sx={carouselControlsStyle.wrapper}>
      <IconButton
        sx={carouselControlsStyle.leftButton}
        onClick={props.onLeft}
      >
        <NavigateBeforeRoundedIcon />
      </IconButton>
      <IconButton
        sx={carouselControlsStyle.rightButton}
        onClick={props.onRight}
      >
        <NavigateNextRoundedIcon />
      </IconButton>
    </Box>
  )
}

const carouselStyle = {
  container: {
    width: '100%',
    height: '200px',
    position: 'relative'
  },
  left: {
    position: 'absolute',
    top: '0px ',
    left: '0',
    width: '40%',
    height: '100%',
    padding: '10px',
    paddingLeft: '0px'
  },
  middleLeft: {
    position: 'absolute',
    top: '0px',
    left: '10%',
    width: '40%',
    height: '100%',
    padding: '5px'
  },
  middle: {
    position: 'absolute',
    top: '0px',
    left: '30%',
    width: '40%',
    height: '100%'
  },
  middleRight: {
    position: 'absolute',
    top: '0px',
    right: '10%',
    width: '40%',
    height: '100%',
    padding: '5px'
  },
  right: {
    position: 'absolute',
    top: '0px',
    right: 0,
    width: '40%',
    height: '100%',
    padding: '10px',
    paddingRight: '0px'
  },
  controlLayer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0px'
  },
  controlWrapper: {
    position: 'absolute',
    top: '0px',
    left: '0',
    width: '100%',
    height: '50px'
  }
}

export const VotingCarousel = (props) => {
  const [swipePosition, setSwipePosition] = useState({
    initialPosition: 0,
    lastPosition: 0
  })
  const { fursuits, votes } = props
  const dispatch = useDispatch()
  const { number } = useSelector(state => state.fursuitVoting)
  const index = isDefined(number) ? fursuits.findIndex((entity) => entity.number === number) : 0

  const left = index - 2
  const right = index + 2

  let sliceN = {}
  if (left < 0) {
    sliceN = [
      ...fursuits.slice(left),
      ...fursuits.slice(0, right + 1)
    ]
  } else if (right >= fursuits.length) {
    sliceN = [
      ...fursuits.slice(left, fursuits.length),
      ...fursuits.slice(0, right - fursuits.length + 1)
    ]
  } else {
    sliceN = fursuits.slice(left, right + 1)
  }

  const moveLeft = () => {
    dispatch(selectFursuit(sliceN[1]))
  }

  const moveRight = () => {
    dispatch(selectFursuit(sliceN[3]))
  }

  const onTouchStart = (e) => {
    setSwipePosition({
      initialPosition: e.targetTouches[0].clientX,
      lastPosition: null
    })
  }

  const onTouchMove = (e) => {
    setSwipePosition({
      ...swipePosition,
      lastPosition: e.targetTouches[0].clientX
    })
  }

  const onTouchEnd = (_e) => {
    const startX = swipePosition.initialPosition
    const endX = swipePosition.lastPosition
    if (notDefined(startX) || notDefined(endX)) {
      return
    }
    const delta = endX - startX
    setSwipePosition({
      initialPosition: 0,
      lastPosition: 0
    })
    if (delta < 0) {
      moveRight()
    } else {
      moveLeft()
    }
  }

  return (
    <Box sx={carouselStyle.container}>
      <Box sx={carouselStyle.left}>
        <VotingCard votes={votes} data={sliceN[0]} loading="eager"/>
      </Box>
      <Box sx={carouselStyle.middleLeft}>
        <VotingCard votes={votes} data={sliceN[1]} loading="eager"/>
      </Box>
      <Box sx={carouselStyle.right}>
        <VotingCard votes={votes} data={sliceN[4]} loading="eager"/>
      </Box>
      <Box sx={carouselStyle.middleRight}>
        <VotingCard votes={votes} data={sliceN[3]} loading="eager"/>
      </Box>
      <Box sx={carouselStyle.middle}>
        <VotingCard votes={votes} data={sliceN[2]} loading="eager"/>
      </Box>
      <Box
        sx={carouselStyle.controlLayer}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      />
      <Box sx={carouselStyle.controlWrapper}>
        <VotingCarouselControls onLeft={moveLeft} onRight={moveRight} />
      </Box>
   </Box>
  )
}
